<template>
  <div>
    <div style="line-height:30px">
      <div style="padding-bottom:20px">
        <p style="font-size: 14px;">请您阅读以下“展台音量规定”并确认遵守。</p>
        <div class="knowBox">
          <h3>2024中国（上海）国际乐器展览会</h3>
          <h3>音量控制规定</h3>
          <h5 style="text-indent: 2em; font-weight: normal;">为了给展商和观众创造一个良好的参展观展环境，并鉴于往年现场音量对整个展会环境氛围的影响，今年主办单位将制定现场音量控制及演出放音的相关规定，对于现场放音超过音量控制范围的，将严格采取相关措施及处罚规定，具体如下：</h5>
          <!--<h5 style="text-indent: 2em;">对于现场放音超过音量控制范围的，将严格采取相关措施及处罚规定，具体如下：</h5>-->
          <h5>展馆设置及规定细则</h5>
          <h5>★ ★静音馆—E1/E2/E3/E4/E5/W2/N1号馆全展期</h5>
          <p style="text-indent: 2em;">10月10-13日（全展期）</p>
          <p style="text-indent: 2em;">--展商音量全天控制在70分贝以下，禁止使用扩音设备并严禁播放音乐。
（可以进行不带功放或扩声器的即兴表演，但时间不超过10分钟,每天不能超过3次，需提前向主办单位申请。）</p>
          <p style="text-indent: 2em;">--对于2024年展会现场违反演出及音量规定的展商，额外制定以下音控规定，并在下一年度即2025年执行：</p>
          <p style="text-indent: 2em;">1. 如再度违反规定，将不给予任何口头警告，一次书面警告后，直接拉电。</p>
          <p style="text-indent: 2em;">2.主办单位有权限制其展位电源容量，并在企业提交电箱需求后做适当控制与调整。</p>
          <h5 style="text-indent: 2em;">在营造更好的馆内洽谈环境的同时，主办方也努力满足广大企业演出的需求，设立了演出舞台，参展商可以将部分的演出移至舞台，主办方也将汇总参展商的演出内容，筛选调整并安排时间段。</h5>
          <!--<p style="text-indent: 2em;">10月11、12日（专业观众日）上午12点前</p>
          <p style="text-indent: 2em;">--严禁展台演出，仅为专业洽谈。</p>
          <p style="text-indent: 2em;">10月11、12日（专业观众日）下午和10月13、14日（专业及公众参观日）全天</p>
          <p style="text-indent: 2em;">--可以在主办单位允许的时间段内展台演出，无演出时段音量全天控制在70分贝以下。</p>
          <p style="text-indent: 2em;">--有展台演出的企业须提前申请，未申请者将禁止进行展台表演。收到展商展台表演申请后，届时主办单位将另发展台表 演时间表供参展商选取相应时间段。</p>
          <p style="text-indent: 2em;">--10月13、14日（专业及公众参观日），展台表演上午限2场，下午限2场。每场表演限时15分钟，表演场次之间将会有一定 的间隔时间，主办单位会将相邻展位的表演时间和舞台位置都进行错开。</p>
          <p>注：打击乐器馆的展商禁止使用扩音设备。如有买家或用户需要敲击试音，不能连接扩声设备，时间不超过5分钟。</p>-->
          <h5>★有声馆— E6/E7/W1/W3/W4/W5/N2号馆 </h5>
          <p style="text-indent: 2em;">10月10、11日（专业观众日）上午12点前</p>
          <p style="text-indent: 2em;">--严禁展台演出，仅为专业洽谈。</p>
          <p style="text-indent: 2em;">10月10、11日（专业观众日）下午和10月12、13日（专业及公众参观日）全天</p>
          <p style="text-indent: 2em;">--可以在主办单位允许的时间段内展台演出，无演出时段音量全天控制在70分贝以下。</p>
          <p style="text-indent: 2em;">--有展台演出的企业须提前申请，未申请者将禁止进行展台表演。收到展商展台表演申请后，届时主办单位将另发展台表演时间表供参展商选取相应时间段。</p>
          <p style="text-indent: 2em;">--每场表演限时15分钟，表演场次之间将会有一定的间隔时间，主办单位会将相邻展位的表演时间和舞台位置都进行错开。</p>
          <p style="text-indent: 2em;">--表演时段的音量必须控制在100分贝以下，非展台表演时段控制在70分贝以下。在非表演时段，禁止播放音乐，如展台中需要播放音像、视频或举办推广活动，音量需要控制于70分贝或以下。</p>
          <p style="text-indent: 2em;">--扩音器不可朝向公众过道或朝向其他展商，扩音设备及舞台只可朝向展位内。</p>
          <p style="text-indent: 2em;">--N2馆禁止使用扩声设备,如有买家或用户需要敲击试音，时间不超过5分钟。</p>
          <p style="text-indent: 2em;">--W1,W3仅限使用乐器音箱，禁止使用舞台音箱，可申请的演出时段为演出时间表中带*的时间段。</p>
          <h5>现场音控及处罚措施</h5>
          <!--<h5>＊表演时段的音量必须控制在100分贝以下，非展台表演时段控制在70分贝以下。在非表演时段，禁止播放音乐，如展台中需要播放音像、视频或举办推广活动，音量需要控制于70分贝或以下。</h5>
          <h5>＊扩音器不可朝向公众过道或朝向其他展商，扩音设备及舞台只可朝向展位内。</h5>
          <h5>现场音控及处罚措施</h5>-->
          <p style="text-indent: 2em;">静音馆音量超过70分贝或携带扩音设备，有声馆在未经主办方许可的时间段表演或展台表演音量超出规定音量，以及违反以上规定的展商，主办单位将先后采取以下措施：</p>
          <p style="text-indent: 2em;">（1）初次违反音控规定的展商将给予口头警告；</p>
          <p style="text-indent: 2em;">（2）若口头警告无效，主办单位将给予展商书面警告；</p>
          <p style="text-indent: 2em;">（3）对于再次违反展台表演音控规定的展商，主办单位将扣除展台押金。</p>
          <p style="text-indent: 2em;">（4）所有申报展台演出的企业（有声馆）均需交纳押金，每家5000元，并通知如再违反将采取拉电措施。</p>
          <p style="text-indent: 2em;">（5）对已扣除押金及违反的展商，主办单位将对此展商展台进行断电处罚，此展商也将被禁止下一届乐器展进行现场演出。</p>
          <p style="text-indent: 2em;">（6）静音馆违反规定（携带扩声设备或进行展台演出的）的企业，将取消下一届乐器展静音馆的展位，移至有声馆。</p>
          <h5 style="text-indent: 2em;">历经二十年，上海国际乐器展已成为了全球最具影响力的展会之一，来自世界各地的买家观众都会在十月齐聚上海，由于乐器发声的需求和展台演出的噪音，对现场商贸洽谈有很大的影响，为进一步提升展会质量，音量控制也成为了展会目前最重要的工作之一，也需要广大参展商的共同配合，主办方也会加强现场的管理工作，三方主办单位将成立领导层管理小组，一同出面劝阻，必要时进行扣除押金、拉电处理，希望广大参展企业能积极配合，自觉遵守相关规定，共创良好的展会环境。</h5>
          <!--<p>对于2023年展会现场违反演出及音量规定的展商，须额外遵守以下音控规定，并在今年即2024年执行：</p>
          <p style="text-indent: 2em; font-weight: bold;">（1）如再度违反规定，将不给予任何口头警告，一次书面警告后，直接拉电。</p>
          <p style="text-indent: 2em; font-weight: bold;">（2）主办单位有权限制其展位电源容量，并在企业提交电箱需求后做适当控制与调整。</p>
          <p style="text-indent: 2em; font-weight: bold;">对于现场违反音控规定的展商，如持续破坏展览环境，情节后果特别严重，主办单位将另行对其收取10000元的罚金，在规定日期内将罚款交纳给主办单位指定银行账户，否则主办单位将不得不取消其下一届乐器展的参展资格。</p>-->
          <h5 style="text-indent: 2em;">※ 以上内容如有变动，以主办单位最后通知为准</h5>
          <h5 style="text-indent: 2em;">请每家参展商确认上述事宜，并填妥下列回执表后，于确认展位合同前签字盖章回传至主办单位办公室，谢谢配合！</h5>
        </div>
        <el-form style="width: 70%; text-align: center;" v-show="this.soundwrap != 'sound'">
          <el-form-item>
            <el-checkbox v-model="sound"><span style="color: red;">请阅读“展台音量规定”并确认遵守</span></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
        <el-form v-show="this.soundwrap === 'sound'"  style="width: 70%; color: red; text-align: center;">您已阅读“展台音量规定”并确认遵守</el-form>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      demoExcel:'./酒店预订介绍.pdf',
      sound: false,
      soundwrap: sessionStorage.getItem('soundwrap')
  }),

  components: {},
  mounted() {

  },
  methods: {
    onSubmit(){
      if(this.sound != true){
        this.$notify({
          title: '请勾选',
          type: '提示',
          duration: 2000
        })
        return false
      }
      api.updatelinkphone({linkPhone:'false',atrLabel2:'sound'}).then((res) => {
        if(res.data.code === 200){
          sessionStorage.setItem('soundwrap','sound')
          this.$router.go(0)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped="scoped">
	.knowBox{
    width: 70%;
    padding: 20px;
    max-height: 1000px;
    border: 1px solid rgb(178, 43, 101);
    overflow-y: scroll;
  }
  .knowBox h3{
    width: 100%;
    text-align: center;
    font-size: 18px;
  }
  .knowBox h5{
    font-size: 14px;
    margin-top: 10px;
  }
  .knowBox p{
    font-size: 14px;
  }

</style>